export default __webpack_public_path__ + "static/media/Geist.9fc309fb.png";